import { createRootRoute, Outlet, redirect } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { GlobalStyles, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import theme, { globalStyles } from '../theme';
import { ToastContainer } from 'react-toastify';
import ErrorBoundary, { ErrorFallback } from '@components/ErrorBoundary';
import { useEffect } from 'react';
import { isAuthenticated } from '@utils/auth';
import axios from 'axios';
import { useMutation } from '@tanstack/react-query';
// import { useAuthStore } from 'store/authStore';

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const authPaths = ['/login', '/register', '/forgot-password', '/reset-password', '/confirm-email', '/account-verified'];
    const isAuthRoute = authPaths.some(
      (path) => location.pathname === path || location.pathname.startsWith(`${path}/`),
    );

    if (!isAuthenticated() && !isAuthRoute) {
      throw redirect({ to: '/login' });
    }
  },
  component: () => {
    // const login = useAuthStore((s) => s.login)

    // const refreshTokenMutation = useMutation({
    //   mutationFn: async() => {
    //     const refreshToken = localStorage.getItem("refreshToken");
    //     if (!refreshToken) throw new Error("No refresh token found");
    //     const response = await axios.post(
    //       "https://interviewer.runasp.net/api/users/refresh-token",
    //       {
    //         refreshToken: refreshToken,
    //       })
    //     return response.data
    //   },
    //   onSuccess: (data) => {
    //     localStorage.setItem("refreshToken", data.refreshToken);
    //     login(data.token, data.roles);
    //   },
    //  onError: (error: any) => {
    //     console.log(error);
    //   }
    // })

    // useEffect(() => {
    //   if(isAuthenticated()){
    //     refreshTokenMutation.mutate();
    //   }
    // }, [])

    return (
      <ErrorBoundary fallback={ErrorFallback}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles styles={globalStyles} />
          <Outlet />
          <TanStackRouterDevtools />
          <ToastContainer />
        </ThemeProvider>
      </ErrorBoundary>
    );
  },
});
